import type { User } from 'pure-js/types/User'

import { isPlatformSuperUser } from './isPlatformSuperUser'

/**
 * True when org-related UI chrome (sidebar switcher label, profile org card,
 * etc.) should be hidden because the user is effectively unaffiliated: a
 * non-super-user whose only membership is the platform default org.
 *
 * The OrganizationSwitcher and the Profile organization card both honor this.
 * Super-users always see their orgs, even when it's just the default — they
 * need to know which tenant context they're operating in.
 */
export function isSoleMembershipPlatformDefault(user: User | null | undefined): boolean {
  if (!user) return false
  if (isPlatformSuperUser(user)) return false
  const memberships = user.organizations ?? []
  if (memberships.length !== 1) return false
  const defaultId = user.platformDefaultOrganizationId
  return defaultId !== undefined && memberships[0]?.organizationId === defaultId
}
